// Feature-detected localStorage. Kiosk WebViews can ship with storage disabled,
// and every access can throw, so every call is guarded. Lives under api/ so both
// store domains share it without claiming a new top-level directory.

let cached: Storage | null | undefined;

function detect(): Storage | null {
  if (cached !== undefined) return cached;
  try {
    const probe = '__izqlt_probe__';
    const store = window.localStorage;
    store.setItem(probe, '1');
    store.removeItem(probe);
    cached = store;
  } catch (e) {
    cached = null;
  }
  return cached;
}

export function readJson<T>(key: string): T | null {
  const store = detect();
  if (!store) return null;
  try {
    const raw = store.getItem(key);
    return raw ? (JSON.parse(raw) as T) : null;
  } catch (e) {
    return null;
  }
}

export function writeJson(key: string, value: unknown): void {
  const store = detect();
  if (!store) return;
  try {
    store.setItem(key, JSON.stringify(value));
  } catch (e) {
    // Quota or disabled storage - the in-memory store stays authoritative.
  }
}

export function removeKey(key: string): void {
  const store = detect();
  if (!store) return;
  try {
    store.removeItem(key);
  } catch (e) {
    // ignore
  }
}
